import { datadogRum } from '@datadog/browser-rum-slim';
import { EBEnvs, getCurrentEnv } from '@eventbrite/feature-detection';
import { useMount } from 'react-use';
import { useEnvContext } from '../../../../context/';

export const useAnalyticsAndMonitoring = () => {
    const envContext = useEnvContext();
    const env = envContext?.env;

    useMount(() => {
        if (env && getCurrentEnv({ env }) === EBEnvs.PROD) {
            datadogRum.onReady(() =>
                datadogRum.setGlobalContextProperty(
                    'view.sub_app',
                    'category-browse',
                ),
            );
        }
    });
};
